@if (organizationItems().size > 0) {
  <dhp-filter-entities-dropdown
    [originalItems]="organizationItems()"
    (itemOutput)="selectedOrganizationId.emit($event)"
  />
}
